import React from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "./SectionHeading";
import JourneyMilestone from "./JourneyMilestone";
import { milestones } from "../../data/roadMapData";

// Years are listed in chronological DOM order whatever the CSS does with them,
// so screen readers and keyboard users always walk 2018 → 2026.
const JourneyTimeline = () => {
  const { t } = useTranslation("roadmap");

  const goToYear = (event, id) => {
    event.preventDefault();
    const target = document.getElementById(`year-${id}`);
    if (!target) return;
    const reduced =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({
      behavior: reduced ? "auto" : "smooth",
      block: "center",
    });
  };

  return (
    <section className="rm-timeline" id="road-map">
      <div className="rm-container">
        <SectionHeading title={t("timeline.title")} />

        <div className="rm-timeline__layout">
          {/* Desktop shortcut list; hidden on small screens where the page is
              short enough to scroll. */}
          <nav className="rm-timeline__nav" aria-label={t("timeline.navLabel")}>
            <ul>
              {milestones.map((milestone) => (
                <li key={milestone.id}>
                  <a
                    href={`#year-${milestone.id}`}
                    onClick={(event) => goToYear(event, milestone.id)}
                  >
                    <span dir="ltr">{milestone.id}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="rm-timeline__track">
            <span className="rm-timeline__line" aria-hidden="true" />
            {milestones.map((milestone) => (
              <JourneyMilestone key={milestone.id} milestone={milestone} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneyTimeline;
